import { useState, useEffect } from 'react';

const useTimer = initSecond => {
  const [remine, setRemine] = useState(initSecond);
  useEffect(() => {
    let tid;
    let last = Date.now();
    function update() {
      const cost = Date.now() - last;
      const diff = parseInt(cost / 1000, 10);
      last = Date.now();
      tid = setTimeout(update, 1000);
      setRemine((fresh) => {
        const leftTime = fresh - diff;
        if (!(leftTime > 0)) {
          clearTimeout(tid);
          return 0;
        }
        return leftTime;
      });
    }
    update();
    return () => {
      clearTimeout(tid);
    };
  }, []);
  return remine;
};

export default useTimer;
